import { ZodType, ZodError } from "zod";

export type ErrorMap<T extends object> = Partial<Record<keyof T, string>>;

export function validateWithZod<T extends object>(
    schema: ZodType<T, any, unknown>,
    data: unknown
): { success: true; data: T } | { success: false; errors: ErrorMap<T> } {
    const result = schema.safeParse(data);
    if (result.success) {
        return { success: true, data: result.data };
    }

    const errors: ErrorMap<T> = {};
    for (const issue of (result.error as ZodError).issues) {
        const key = issue.path[0] as keyof T;
        if (!(key in errors)) {
            errors[key] = issue.message;
        }
    }
    return { success: false, errors };
}
